import { CalendarDays } from 'lucide-react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import CustomSelect from '../../components/SelectBox';

const AutocompleteCountry = ({
  field,
  formData,
  filteredTopCountryData = [],
  setFormData,
  intakeYears = [],
  disabled,
  source,
}: any) => {
  const [countryInput, setCountryInput] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const selectedCountries = useMemo(() => {
    return formData.country?.length
      ? filteredTopCountryData.filter((country: any) => formData.country.includes(country.id))
      : [];
  }, [formData.country, filteredTopCountryData]);

  const filteredCountries = useMemo(() => {
    if (!countryInput.trim()) return filteredTopCountryData;
    return filteredTopCountryData.filter((country: any) =>
      country.country_name.toLowerCase().includes(countryInput.toLowerCase()),
    );
  }, [countryInput, filteredTopCountryData]);

  const handleCountrySelect = (country: any) => {
    const alreadySelected = formData.country?.includes(country.id);
    const updatedList = alreadySelected
      ? formData.country.filter((id: any) => id !== country.id)
      : [...(formData.country || []), country.id];
    setFormData({ ...formData, country: updatedList });
    setShowDropdown((prev)=> !prev);
  };

  useEffect(() => {
    const closeOnClickOutside = (e: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', closeOnClickOutside);
    return () => document.removeEventListener('mousedown', closeOnClickOutside);
  }, []);

  // handleRemoveCountry:
  const handleRemoveCountry = (countryId:string) => {
    setFormData({ ...formData, country: formData?.country.filter((id:any) => id !== countryId) });
  }

  return (
    <>
      {source !== 'college-review' && (
        <div>
          <div className="font-inter font-medium text-xs text-[#404D61] px-1 flex items-center gap-x-1 mb-1">
            <CalendarDays size={16}/>
            <label htmlFor="intake-year" className="text-sm lg:text-base">
              Intake Year
            </label>
          </div>
          {/* <select
            id="intake-year"
            value={formData.year || 'select-year'}
            onChange={(e) =>
              setFormData({
                ...formData,
                year: e.target.value === 'select-year' ? '' : e.target.value,
              })
            }
            className={`w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 ${formData.year ? "text-black" : "text-gray-500"}`}
            required
          >
            <option value="select-year" disabled >
              Select Intake Year
            </option>
            {intakeYears.map((year: any) => (
              <option key={year} value={year} className="intake_year">
                {year}
              </option>
            ))}
          </select> */}
          <CustomSelect
            id="intake-year"
            options={intakeYears}
            value={formData.year}
            placeholder="Select Intake Year"
            onChange={(val) =>
              setFormData({
                ...formData,
                year: val,
              })
            }
          />
        </div>
      )}

      <div className="font-sans space-y-1" ref={dropdownRef}>
        <div className="font-inter font-medium text-xs text-[#404D61] px-1 flex items-center gap-x-2 mb-1">
          {field?.icon}
          <label className="text-sm lg:text-base">{field.label}</label>
        </div>
      
        <input
          type="text"
          placeholder={field.placeholder}
          value={countryInput}
          onChange={(e) => setCountryInput(e.target.value)}
          onFocus={() => !disabled && setShowDropdown(true)}
          disabled={disabled}
          autoComplete="new-password"
          name="country-autocomplete-off"
          className="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
        />

        {showDropdown && (
          <ul className="absolute z-10 w-full md:w-1/2  bg-white border border-gray-300 rounded-md mt-1 max-h-56 overflow-y-auto shadow-md text-sm">
            {filteredCountries.length > 0 ? (
              filteredCountries.map((country: any) => {
                const isSelected = formData.country?.includes(country.id);
                return (
                  <li
                    key={country.id}
                    onClick={() => handleCountrySelect(country)}
                    className={`px-4 py-2 cursor-pointer hover:bg-blue-100 ${
                      isSelected ? 'bg-blue-100 text-black' : ''
                    }`}
                  >
                    {country.country_name}
                  </li>
                );
              })
            ) : (
              <li className="px-4 py-2 text-gray-500">No countries found</li>
            )}
          </ul>
        )}

        {selectedCountries.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-2 h-14 overflow-auto">
            {selectedCountries.map((country: any) => (
              <span key={country.id} className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full h-fit">
                {country.country_name}
                <button 
                type='button'
                className='ml-2 text-base text-red-500'
                onClick={()=> handleRemoveCountry(country.id)}
                >
                  x
                </button>
              </span>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default AutocompleteCountry;
